<template>
  <template v-if="isMainModal">
    <div class="modal fade" :id="idData" tabindex="-1" :aria-labelledby="idData + 'Label'">
      <div class="modal-dialog modal-md modal-xl">
        <div class="modal-content modal-content-border-radius">
          <div class="modal-header" :class="{ 'modal-header-border p-0': !showTitle }">
            <h5 class="modal-title" :id="idData + 'Label'" v-if="showTitle">{{ modalTitle }}</h5>
            <ButtonComponent type="button" data-bs-dismiss="modal" aria-label="Close" class="modal-close-button">
              <template #btnContent>
                <span><img src="/assets/images/xTimes-1.svg"></span>
              </template>
            </ButtonComponent>
          </div>
          <div class="modal-body" :class="{ 'modal-body-padding': !showTitle }">
            <slot name="body-content"></slot>
          </div>
        </div>
      </div>
    </div>
  </template>

  <!-- Custom-bootstrap modal container -->

  <template v-else-if="!isMainModal">
    <div :id="id" class="modal modal-custom" :class="zIndexCustom">
      <div class="modal-dialog modal-dialog-margin modal-md modal-lg modal-xl modal-dialog--open">
        <div class="modal-content modal-content-border-radius">
          <div class="modal-header image-modal-header">
            <ButtonComponent type="button" @click="close({ id: id, backdrop: backdrop, bodyOverflow: bodyOverflow })"
              aria-label="Close" class="modal-close-button">
              <template #btnContent>
                <span><img src="/assets/images/xTimes-1.svg" alt="times"></span>
              </template>
            </ButtonComponent>
          </div>
          <div v-show="showLink" class="vehicle-info-container-wrapper-header">
            <a @click="close({ id: id, backdrop: backdrop, bodyOverflow: bodyOverflow })" class="d-flex">
              <img src="/assets/images/arrow-right-1.svg" alt="arrow-1">
              <div class="ps-3">{{ $t('choose-vehicle.back_to_list') }}</div>
            </a>
          </div>
          <slot name="body-content"></slot>
        </div>
      </div>
    </div>
  </template>

</template>

<script lang="ts">
import { defineComponent } from 'vue';
import './modal.scss';
// @ts-ignore
import ButtonComponent from "../../components/Button/ButtonComponent.vue";

export default defineComponent({
  name: 'ModalComponent',
  components: { ButtonComponent },
  emits: ['close'],
  props: {
    idData: {
      type: String,
      default: '',
      required: false
    },
    modalTitle: {
      type: String,
      default: '',
      required: false
    },
    showTitle: {
      type: Boolean,
      default: true,
      required: false
    },
    isMainModal: {
      type: Boolean,
      default: true,
      required: false
    },
    zIndexCustom: {
      type: String,
      default: ''
    },
    showLink: {
      type: Boolean,
      default: false
    },

    id: {
      type: String,
      default: '',
    },

    backdrop: {
      type: String
    },

    bodyOverflow: {
      type: String
    }
  },
  data() {
    return {
    };
  },

  methods: {
    close(payload) {

      let parentEl = document.querySelector('body');
      let backdrop = document.querySelector('.' + payload.backdrop);

      let modal = document.querySelector('#' + payload.id);
      // @ts-ignore
      modal.style.display = 'none';

      // @ts-ignore
      parentEl.classList.remove(payload.bodyOverflow);
      if (backdrop && parentEl) {
        backdrop.classList.remove('fade-in-backdrop');
        backdrop.classList.add('fade-out-backdrop');

        backdrop.addEventListener('animationend', () => {
          if (backdrop && parentEl) {
            parentEl.removeChild(backdrop);
          }
        })
      }

    },

  },
});

</script>

<style lang="scss"></style>